import {
  call,
  put,
  select,
  fork,
  cancel,
  takeEvery,
  delay,
  take,
  race,
} from 'redux-saga/effects';
import {
  CREATE_BOX,
  CREATE_MANAGERS,
  SET_STATUS_LOCK,
  CANCEL_SAGA,
  PULL_REQUEST,
  CANCEL_SAGA_PULL,
} from './constant';
import { BOXES, DEVICES, BASE_API_PATH, USERS, BOX } from 'api';
import request from 'utils/request';
import dataProvider from '../../../dataProvider';
import filter from 'lodash/filter';

export function* createBoxRequest(action) {
  const { params, id } = action;
  const { getBoxes, query } = action.getFunc;
  const dataInstance = dataProvider();
  try {
    const response = yield call(dataInstance['create'], BOXES, {
      ...params,
    });
    yield call(dataInstance['update'], DEVICES, {
      box_id: response.id,
      id,
    });
    yield call(getBoxes, query);
  } catch (error) {
    console.log(error);
  }
}

export function* createManagersRequest(action) {
  const { userId, storageId, getUsers } = action;
  try {
    const reqObj = {
      method: 'patch',
      data: [{ permissions: ['full_access'], warehouse_id: storageId }],
    };
    yield call(
      request,
      `${BASE_API_PATH}${USERS}/${userId}/warehouse_permissions`,
      reqObj,
    );
    getUsers({
      role: 'manager',
    });
  } catch (error) {
    console.log(error);
  }
}

export function* setLocksRequest(action) {
  const { id, status } = action;
  try {
    const reqObj = {
      method: 'post',
      data: {
        reason: '',
      },
    };
    yield call(
      request,
      `${BASE_API_PATH}${BOX}/${id}/${status === 'open' ? 'open' : 'close'}`,
      reqObj,
    );
  } catch (error) {
    console.log(error);
  }
}

export function* pullRequest(action) {
  let { currentStatus, id, storageId } = action;
  const { getBoxes, query } = action.getFunc;
  try {
    while (true) {
      try {
        const response = yield call(
          request,
          `${BASE_API_PATH}${BOXES}?warehouse_id=${storageId}`,
          { method: 'get' },
        );
        const filtered = filter(response, (item) => {
          return item.id === id;
        });
        const valueResponce = filtered[0].device.telemetry.open;
        if (valueResponce !== currentStatus) {
          yield call(getBoxes, query);
          currentStatus = valueResponce;
        }
        yield delay(5000);
      } catch (error) {
        console.log(error);
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* setlocksRequestWatch() {
  while (true) {
    const {
      currentStatus,
      status,
      getFunc,
      id,
      storageId,
      setLoader,
    } = yield take(SET_STATUS_LOCK);
    yield race({
      task: call(setLocksRequest, {
        currentStatus,
        status,
        getFunc,
        id,
        storageId,
        setLoader,
      }),
      cancel: take(CANCEL_SAGA),
    });
  }
}

export function* pullRequestWatch() {
  while (true) {
    const { currentStatus, getFunc, id, storageId } = yield take(PULL_REQUEST);
    yield race({
      task: call(pullRequest, {
        currentStatus,
        getFunc,
        id,
        storageId,
      }),
      cancel: take(CANCEL_SAGA_PULL),
    });
  }
}

export default function* createBoxSaga() {
  yield takeEvery(CREATE_BOX, createBoxRequest);
  yield takeEvery(CREATE_MANAGERS, createManagersRequest);
  yield fork(pullRequestWatch);
  yield fork(setlocksRequestWatch);
}
